import { formatDate, formatToDevanagariStyle } from "@/utilities/helper"

export const columns = [
  {
    accessorKey: "product_name",
    header: "Name",
  },
  {
    accessorKey: "product_sku",
    header: "SKU",
  },
  {
    accessorKey: "total_quantity_sold",
    header: "Quantity Sold",
  },
  {
    accessorKey: "total_sales",
    header: "Total Sales",
    cell: ({ row }) =>
      `Rs. ${formatToDevanagariStyle(row.original.total_sales)}`,
  },
]
